import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { classNames } from 'primereact/utils';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';
import { useNavigate } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FaTrash } from 'react-icons/fa';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik';
import './BillableDashboard.css';

const BillableDashboard = () => {

    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState('');
    const toast = useRef(null);

    const [excelFile, setExcelFile] = useState(null);
    const [isFormSubmitLoadder, setIsFormSubmitLoadder] = useState(false);
    const [isReplaceConfirmationModalOpen, setIsReplaceConfirmationModalOpen] = useState(false);
    const [isReplaceBillableConfigModelModalOpen, setIsReplaceBillableConfigModelModalOpen] = useState(false);

    const [typeError, setTypeError] = useState(null);
    const [selectedExcelFile, setSelectedExcelFile] = useState();

    const [isRelplace, setIsRelplace] = useState('N');
    const [isRelplaceMessage, setIsRelplaceMessage] = useState("null");
    const [startDate, setStartDate] = useState("null");
    const [endDate, setEndDate] = useState("null");

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
        useState(false);
    const formik = useFormik({
        initialValues: {
            billable: [
                {
                    excelTitle: '',
                    header: '',
                }
            ]
        },


    });
    // -------------------------------------------------------------------------------------
    const [missingValues, setMissingValues] = useState([]);
    const [billableConfigMissing, setBillableConfigMissing] = useState([]);
    const [billableConfigData, setBillableConfigData] = useState([]);
    const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

    // -------------------------------------------------------------------------------------
    // const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
    // -------------------------------------------------------------------------------------

    const openModal = () => {
        setBillableConfigMissing([]);
        setEndDate('null')
        setStartDate('null')
        setIsModalOpen(true);
    };

    useEffect(() => {
        // console.log('Fetching projects...xx');
        getProjectType();
        getbillableTitle();

        const storedRowData = localStorage.getItem('selectedBillableRow');
        if (storedRowData) {
            setSelectedProduct(JSON.parse(storedRowData)); // Set the selected row data
        }

    }, []);

    const getbillableTitle = (project) => {

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'billable-config', { headers })
            .then((response) => {


                var data2 = response.data.billableTitle;


                setBillableConfigData(data2);

            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });


    };

    const getProjectType = (project) => {

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            //'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };

        axios.get(Api.API_BASE_URL + 'billable-dashboard', { headers })
            .then((response) => {

                var data = response.data.result;

                setProjectType(data);
                setSearchProjectType(data);

                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });


    };

    const handleClick = (payPeriodStartDate, payPeriodEndDate) => {
        localStorage.setItem('payPeriodStartDate', payPeriodStartDate);
        localStorage.setItem('payPeriodEndDate', payPeriodEndDate);
        navigate('/billable');
    };

    const [payPeriodStartDate, setPayPeriodStartDate] = useState('');
    const [payPeriodEndDate, setPayPeriodEndDate] = useState('');

    const handleDelete = () => {
        var _body = {
            startDate: payPeriodStartDate,
            endDate: payPeriodEndDate,
        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(Api.API_BASE_URL + 'billable-delete', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                console.log(response.result);

                toast.current.show({ severity: 'success', summary: 'Success', detail: response.result });
                getProjectType();

                setIsDeleteConfirmationModalOpen(false)

            })
            .catch((error) => {
                setIsDeleteConfirmationModalOpen(false)

                console.error("Error:", error);
            });
    };


    const handleDeleteProject = (payPeriodStartDate, payPeriodEndDate) => {

        setPayPeriodStartDate(payPeriodStartDate);
        setPayPeriodEndDate(payPeriodEndDate);
        setIsDeleteConfirmationModalOpen(true);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>

                <div onClick={(e) => e.stopPropagation()}>

                    <FaTrash title='Delete The File' onClick={() => handleDeleteProject(rowData.payPeriodStartDate, rowData.payPeriodEndDate)} style={{ color: 'darkred' }} />

                </div>
            </React.Fragment>
        );
    };

    // const searchrole = (searchValue) => {
    //     console.log('searchValue', searchValue);

    //     setProjectType([]);
    //     const searchResult = searchProjectType.filter((item) =>
    //         item.excelTitle.toLowerCase().includes(searchValue.toLowerCase())
    //     );

    //     setProjectType(searchResult);
    //     console.log(searchResult)
    // }

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);
        setGlobalFilter(searchValue);
    
        // Convert search value to lowercase for case-insensitive comparison
        const lowercasedValue = searchValue.toLowerCase();
    
        const searchResult = searchProjectType.filter((item) => {
            const name = `${item.first_name} ${item.last_name}`.toLowerCase(); // Combine first and last name
            const payPeriodStartDate = item.payPeriodStartDate.toLowerCase();
            const timestamp = item.timestamp.toLowerCase();
    
            return (
                name.includes(lowercasedValue) ||
                payPeriodStartDate.includes(lowercasedValue) ||
                timestamp.includes(lowercasedValue)
            );
        });
    
        setProjectType(searchResult);
        console.log(searchResult);
    };

    const header = (
        <div className="billable-dashboard-tablebar">
            <div>
                <div className="billable-dashboard-table-title">Uploaded Pay Periods</div>
                <div className="billable-dashboard-table-subtitle">Open a pay period to review billable vs unbillable details.</div>
            </div>
            <span className="p-input-icon-left billable-dashboard-search">
                <i className="pi pi-search" />
                <InputText className="input-field" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search pay period, timestamp, or uploader" />
            </span>
        </div>
    );
    const getPeaytPeriods = (startDate, endDate) => {
        return startDate + ' : ' + endDate;
    }

    const totalUploads = projectType.length;


    const handleFile = (e) => {
        let fileTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        let selectedFile = e.target.files[0];

        setSelectedExcelFile(selectedFile)
        if (selectedFile) {
            if (selectedFile && fileTypes.includes(selectedFile.type)) {
                setTypeError(null);
                let reader = new FileReader();
                reader.readAsArrayBuffer(selectedFile);
                reader.onload = (e) => {
                    setExcelFile(e.target.result);
                }
            }
            else {
                setTypeError('Please select only excel file types');
                setExcelFile(null);
            }
        }
        else {
            console.log('Please select your file');
        }
    }
    const handleFileSubmit = async (e) => {
        e.preventDefault();
        // start Loader

        if (excelFile !== null) {
            setIsFormSubmitLoadder(true)

            const formData = new FormData();


            formData.append("userId", localStorage.getItem('user_id'));
            formData.append("roleId", localStorage.getItem('role_id'));
            formData.append("startDate", startDate);
            formData.append("endDate", endDate);
            formData.append("isRelplace", isRelplace);
            formData.append("excel_file", selectedExcelFile);

            if (billableConfigMissing.length !== 0) {
                formData.append("billable", JSON.stringify(formik.values.billable));
            }
            // formData.append("billable", [{ "excelTitle": "00-BRDN:009-Sales.Lead Processing 0000000", "header": "Billable" }, { "excelTitle": "00-BRDN:009-Sales.Lead Processing 1212", "header": "Billable" }]);

            const token = localStorage.getItem('authToken');
            const headers = {
                Authorization: token ? `Bearer ${token}` : ''
            };

            fetch(Api.API_BASE_URL + 'billable-upload', {
                method: "POST",
                headers: headers,
                body: formData,
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setIsFormSubmitLoadder(false)
                    if (Josn.error !== '') {

                        // End Loader
                        if (Josn.isRelplace === "Y") {
                            setIsModalOpen(false)
                            setIsRelplaceMessage(Josn.error.toString());

                            setIsReplaceConfirmationModalOpen(true)

                            setIsRelplace(Josn.isRelplace)
                        } else if (Josn.isBillableConfig === 'Y') {
                            var t = [];
                            setIsModalOpen(false)
                            for (let index = 0; index < Josn.billable.length; index++) {

                                t.push({ header: '', excelTitle: Josn.billable[index] })
                            }
                            formik.setFieldValue(`billable`, t);
                            setBillableConfigMissing(t)
                            setIsReplaceBillableConfigModelModalOpen(true)
                            //setBillableConfigMissing(Josn.billable)
                            // toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.result });
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                        }

                    } else {
                        // End Loader
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

                        setIsModalOpen(false)
                        setIsReplaceConfirmationModalOpen(false)
                        setIsReplaceBillableConfigModelModalOpen(false)

                        setExcelFile(null);
                        setIsRelplace('N');

                        // added by suraj
                        getProjectType();

                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });



        }
    };

    const onRowSelect = (e) => {
        const rowData = e.data;

        setSelectedProduct(rowData); // Set the selected product
        localStorage.setItem('selectedBillableRow', JSON.stringify(rowData)); // Store selected row data


        handleClick(rowData.payPeriodStartDate, rowData.payPeriodEndDate);
    };



    return (
        <>
            <div className="dashboard-wrapper billable-dashboard-page">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="dashboard-content-card billable-dashboard-card pagination-datable-height">
                    <div className="dashboard-toolbar billable-dashboard-toolbar">
                        <div className="billable-dashboard-toolbar-copy">
                            <div className="billable-dashboard-kicker">Billable vs Unbillable</div>
                            <h1 className="billable-dashboard-title">Billable Upload Dashboard</h1>
                            <p className="billable-dashboard-description">Manage uploaded pay periods and open a pay period to review billable vs unbillable details.</p>
                        </div>

                        <div className="billable-dashboard-actions">
                            <div className="billable-dashboard-stat">
                                <span className="billable-dashboard-stat-label">Uploads</span>
                                <strong className="billable-dashboard-stat-value">{totalUploads}</strong>
                            </div>

                            <button type="button" title='Upload a new File' className="billable-dashboard-add" onClick={openModal} >
                                <span className="billable-dashboard-add-icon">+</span>
                                <span>Add Pay Period</span>
                            </button>
                        </div>
                    </div>

                    <div className="table-responsive-wrapper billable-dashboard-table-panel">
                        {isLoading ? (
                            <div className="loading-spinner billable-dashboard-loading">
                                <span>Loading dashboard data...</span>
                                <div className="spinner"></div>
                            </div>
                        ) : (
                            <DataTable
                                value={projectType}
                                paginator
                                rows={15}
                                tableStyle={{ minWidth: '50rem' }}
                                className="billable-dashboard-table"
                                selectionMode="single"
                                selection={selectedProduct}
                                onRowSelect={onRowSelect}
                                onSelectionChange={(e) => setSelectedProduct(e.value)}
                                header={header}
                                globalFilter={globalFilter}
                                stripedRows
                                showGridlines={false}
                                paginatorClassName="billable-dashboard-paginator"
                                emptyMessage="No pay periods found."
                            >

                                <Column key="action" body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }} />

                                <Column key="timestamp" field="timestamp" header="Timestamp" />
                                <Column key="payPeriodStartDate" field="payPeriodStartDate" header="Pay Period" body={(e) => getPeaytPeriods(e.payPeriodStartDate, e.payPeriodEndDate)} />
                                <Column header="Name" body={(rowData) => `${rowData.first_name} ${rowData.last_name}`} />
                            </DataTable>
                        )}
                    </div>
                </div>
            </div>

            <Dialog
                header="Upload Pay Period Data"
                visible={isModalOpen}
                style={{ width: '30vw', maxWidth: '520px' }}
                contentStyle={{ overflow: 'visible' }}
                onHide={() => setIsModalOpen(false)}
                className="p-fluid billable-dashboard-dialog"
            >
                <div className="billable-dashboard-dialog-card">
                    <form onSubmit={handleFileSubmit} className="billable-dashboard-dialog-form">
                        <div className="grid">
                            <div className="col-6">
                                <label className="billable-dashboard-field-label">Start Date</label>
                                <input
                                    type="date"
                                    className="billable-dashboard-field-input"
                                    value={startDate}
                                    required
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>
                            <div className="col-6">
                                <label className="billable-dashboard-field-label">End Date</label>
                                <input
                                    type="date"
                                    className="billable-dashboard-field-input"
                                    value={endDate}
                                    required
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="mt-1">
                            <label className="billable-dashboard-field-label">Upload File</label>
                            <input
                                type="file"
                                className="billable-dashboard-field-input billable-dashboard-file-input"
                                required
                                onChange={handleFile}
                            />
                        </div>

                        <div className="billable-dashboard-dialog-actions">
                            <button 
                                type="button" 
                                className="billable-dashboard-dialog-button billable-dashboard-dialog-button-secondary"
                                onClick={() => setIsModalOpen(false)}
                            >
                                Cancel
                            </button>
                            {isFormSubmitLoadder ? (
                                <button type='button' className='billable-dashboard-dialog-button billable-dashboard-dialog-button-primary billable-dashboard-dialog-button-loading'>
                                    <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" />
                                </button>
                            ) : (
                                <button type='submit' className='billable-dashboard-dialog-button billable-dashboard-dialog-button-primary'>
                                    Submit
                                </button>
                            )}
                        </div>

                        {typeError && (
                            <div className="billable-dashboard-dialog-error">
                                {typeError}
                            </div>
                        )}
                    </form>
                </div>
            </Dialog>

            {isReplaceBillableConfigModelModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Confirmation</h5>
                            <button className="modal-closex"
                                onClick={(e) => {
                                    setIsReplaceBillableConfigModelModalOpen(false)
                                }}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            {billableConfigMissing.map((item, key) => (
                                <div className="flex">
                                    <div className="col-6 mt-2">
                                        <label className='Leads-heading' >Excel Title</label>
                                        <InputText
                                            disabled
                                            id="excelTitle"
                                            name="excelTitle"
                                            value={formik.values.billable[key].excelTitle}
                                            onChange={(e) => {
                                                console.log(e.target.value);
                                                formik.setFieldValue(`billable.${key}.excelTitle`, e.target.value);
                                            }}
                                            className={classNames('p-2')} style={{ width: '100%' }}
                                        />
                                    </div>
                                    <div className="col-6 mt-2">
                                        <label className='Leads-heading' >Excel Title</label>
                                        <Dropdown
                                            optionValue='id'
                                            id="header"
                                            name="header"
                                            placeholder="Select a Header"
                                            options={billableConfigData}
                                            optionLabel="name"
                                            value={formik.values.billable[key].header}

                                            onChange={(e) => {
                                                console.log(e.value);
                                                formik.setFieldValue(`billable.${key}.header`, e.value);
                                            }}
                                            className={classNames('p-2',)} style={{ width: '100%' }}
                                        />

                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" title='Cancel' onClick={(e) => setIsReplaceBillableConfigModelModalOpen(false)}>
                                Cancel
                            </button>

                            {isFormSubmitLoadder ? (
                                <button className='delete-buttonx' title='Delete' >   <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" /></button>
                            ) : (<button className="delete-buttonx" onClick={handleFileSubmit}>
                                SAVE
                            </button>)}



                        </div>
                    </div>
                </div>
            )}

            {isReplaceBillableConfigModelModalOpen && (
                <Dialog
                    header="Add Job Code in Billable vs Unbillable Config"
                    visible={isReplaceBillableConfigModelModalOpen}
                    style={{ width: '50vw' }}
                    onHide={() => setIsReplaceBillableConfigModelModalOpen(false)}
                >
                    <div className="modal-bodyx">
                        {billableConfigMissing.map((item, key) => (
                            <div className="flex" key={key}>
                                <div className="col-6 mt-2">
                                    <label className='Leads-heading'>Job Code</label>
                                    <InputText
                                        disabled
                                        id="excelTitle"
                                        name="excelTitle"
                                        value={formik.values.billable[key].excelTitle}
                                        onChange={(e) => {
                                            console.log(e.target.value);
                                            formik.setFieldValue(`billable.${key}.excelTitle`, e.target.value);
                                        }}
                                        className={classNames('p-2')}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                                <div className="col-6 mt-2">
                                    <label className='Leads-heading'>Header</label>
                                    <Dropdown
                                        optionValue='id'
                                        id="header"
                                        name="header"
                                        placeholder="Select a Header"
                                        options={billableConfigData}
                                        optionLabel="name"
                                        value={formik.values.billable[key].header}
                                        onChange={(e) => {
                                            console.log(e.value);
                                            formik.setFieldValue(`billable.${key}.header`, e.value);
                                        }}
                                        className={classNames('p-2')}
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="modal-footer-cancelx pb-2" style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                        <button className="cancel-buttonx" title='Cancel' onClick={() => setIsReplaceBillableConfigModelModalOpen(false)}>
                            Cancel
                        </button>

                        {isFormSubmitLoadder ? (
                            <button className='delete-buttonx' title='Delete'>
                                <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" animationDuration=".5s" />
                            </button>
                        ) : (
                            <button className="delete-buttonx" onClick={handleFileSubmit}>
                                SAVE
                            </button>
                        )}
                    </div>
                </Dialog>
            )}

            {/* ---------------------------------------------------------------*/}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={() => setIsDeleteConfirmationModalOpen(false)}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>Are you sure you want to delete this ?</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" title='Cancel' onClick={() => setIsDeleteConfirmationModalOpen(false)}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" title='Delete' onClick={() => handleDelete()}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

// export default BillableDashboard
export default React.memo(BillableDashboard);